import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import '../../styles/components/endowmentForm.css';

const EndowmentForm = ({
  alias,
  setAlias,
  recipient,
  handleRecipientChange,
  releaseDate,
  setReleaseDate,
  maxReleaseDate,
  termsAccepted,
  setTermsAccepted,
  isEditing,
  endowmentExists,
  recipientStatus,
  isLoading,
  onEdit,
  onCancel,
  onViewTerms,
  onRefresh,
  onDelete,        // Add delete handler
  onResend         // Add resend handler
}) => {
  const renderStatusBadge = () => {
    if (!recipientStatus) return null;

    if (recipientStatus.is_declined) {
      return <span className="endowment-badge rejected">Rejected</span>;
    } else if (recipientStatus.is_accepted) {
      return <span className="endowment-badge accepted">Accepted</span>;
    } else {
      return <span className="endowment-badge pending">Pending</span>;
    }
  };

  return (
    <div className="endowment-form-container mb-4">
      <Row className="gy-3 endowment-form-row">
        <Col xs={12} md={3}>
          <Form.Group className="endowment-form-group">
            <Form.Label className="text-black endowment-label">Alias</Form.Label>
            <Form.Control
              type="text"
              className="endowment-input"
              value={alias}
              onChange={(e) => setAlias(e.target.value)}
              disabled={!isEditing}
            />
          </Form.Group>
        </Col>

        <Col xs={12} md={4}>
          <Form.Group className="endowment-form-group">
            <Form.Label className="text-black endowment-label">Recipient Email</Form.Label>
            <div className="endowment-recipient-input-wrapper">
              <Form.Control
                type="email"
                className="endowment-input"
                value={recipient}
                onChange={(e) => handleRecipientChange(e.target.value)}
                disabled={!isEditing}
              />
              {renderStatusBadge()}
            </div>
          </Form.Group>
        </Col>

        <Col xs={12} md={3}>
          <Form.Group className="endowment-form-group">
            <Form.Label className="text-black endowment-label">Release Date</Form.Label>
            <Form.Control
              type="date"
              className="endowment-input"
              value={releaseDate}
              onChange={(e) => setReleaseDate(e.target.value)}
              disabled={!isEditing}
              readOnly={true}
              max={maxReleaseDate}
              title={maxReleaseDate ? `Maximum allowed date: ${new Date(maxReleaseDate).toLocaleDateString()}` : ''}
            />

          </Form.Group>
        </Col>

        <Col xs={12} md={6}>
          <Form.Check
            type="checkbox"
            id="terms-checkbox"
            className="endowment-terms-checkbox"
            label={
              <span className="text-black">
                I accept the{' '}
                <a
                  href="#"
                  className="endowment-terms-link"
                  onClick={(e) => {
                    e.preventDefault();
                    onViewTerms();
                  }}
                >
                  Terms and Conditions
                </a>
              </span>
            }
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
            disabled={!isEditing}
          />
        </Col>
      </Row>

      <Row className="mt-4 gy-3 endowment-actions-row align-items-center">
        <Col xs={12} md={8}>
          <Row className="g-2">
            {/* Always show Edit/Save button */}
            <Col xs={6} sm={3} md={2}>
              <Button
                className="w-100 endowment-btn"
                variant={isEditing ? 'success' : 'primary'}
                onClick={isLoading ? undefined : onEdit}  // Prevent onClick when loading
                disabled={isLoading}
              >
                <i className={`fas ${isEditing ? 'fa-save' : 'fa-pencil-alt'} me-1 ${isLoading ? 'fa-spin' : ''}`}></i>
                {isLoading && isEditing ? 'Saving...' : isEditing ? 'Save' : endowmentExists ? 'Edit' : 'Create Endowment'}
              </Button>
            </Col>

            {endowmentExists && (
              <Col xs={6} sm={3} md={2}>
                <Button
                  className="w-100 endowment-btn"
                  variant="danger"
                  onClick={onDelete}
                  disabled={isLoading}
                >
                  <i className="fas fa-trash me-1"></i>
                  Delete
                </Button>
              </Col>
            )}

            {/* Only render Cancel button column when editing */}
            {isEditing && (
              <Col xs={6} sm={3} md={2}>
                <Button
                  className="w-100 endowment-btn"
                  variant="secondary"
                  onClick={onCancel}
                >
                  <i className="fas fa-times me-1"></i>
                  Cancel
                </Button>
              </Col>
            )}

            {/* Only render Resend button column when recipient declined */}
            {recipientStatus?.is_declined && (
              <Col xs={6} sm={3} md={2}>
                <Button
                  className="w-100 endowment-btn"
                  variant="warning"
                  onClick={onResend}
                  disabled={isLoading}
                >
                  <i className="fas fa-paper-plane me-1"></i>
                  Resend
                </Button>
              </Col>
            )}

            <Col xs={6} sm={3} md={2} className="text-md-end text-center">
              <Button
                className="endowment-refresh-btn"
                variant="outline-primary"
                onClick={onRefresh}
                disabled={isLoading}
              >
                <i className={`fas fa-sync ${isLoading ? 'fa-spin' : ''}`}></i>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default EndowmentForm;